<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        span.dateHeader {{ $t('users.filters.registration_date.value') }}
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
        ods-tooltip(:content='$t("users.users_filters.button_new_user")', placement='bottom')
          ods-button(
            v-if='canAdminUserAdvanced',
            size='mini',
            icon='ods-icon-upload'
            @click.native='handleGoCreateUser')
            | {{ $t('users.users_filters.button_new_user') }}
        ods-tooltip(:content='$t("users.users_filters.button_reset_users")', placement='bottom')
          ods-button(
            v-if='canAdminUserAdvanced',
            size='mini',
            icon='ods-icon-reset'
            @click.native='handleGoResetUsers')
            | {{ $t('users.users_filters.button_reset_users_tt') }}
        ods-tooltip(:content='$t("users.users_filters.button_mass_usercharge")', placement='bottom')
          ods-button.rightbut(
            v-if='canAdminUserAdvanced',
            size='mini',
            icon='ods-icon-upload'
            @click.native='handleGoMassiveCharge')
            | {{ $t('users.users_filters.button_mass_usercharge') }}

      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            ods-select(
              ref='filterBy',
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')

              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'projectId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'partyId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterParties',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'partyType'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='formatterLabel(option.type)',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'isPartySponsor' || selected.prop === 'enable'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("msg_generics.question." + option.type)',
                      :value='option.id')
                  ods-select(v-else
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.code',
                      :value='option')
              //- TRIAL
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'trial')")
                ods-form-item.others-input(prop='trial')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.trial',
                    @input='getSecondValue')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string' && (selected.prop !== 'trial')")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')

              //- Date Type
              div(v-else-if="selected.componente === 'date'")
                ods-form-item(prop='filterDatePickerValue')
                  ods-date-picker(
                    v-model='filterForm.filterDatePickerValue',
                    type='daterange',
                    :picker-options='pickerOptions2',
                    @change='getDateRangePickerValue',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    :format='$t("date_format_calendar")',
                    prefix-icon='prefix-icon-date-time-picker',
                    align='right')

              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-if="(selected.prop === 'completeName')")
              ods-form-item.others-input(prop='thirdValue')
                ods-input(
                  :placeholder='$t(selected.placeholderFirstSurname)',
                  v-model='filterForm.thirdValue',
                  @input='getThirdValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-if="(selected.prop === 'completeName')")
              ods-form-item.others-input(prop='fourthValue')
                ods-input(
                  :placeholder='$t(selected.placeholderSecondSurname)',
                  v-model='filterForm.fourthValue',
                  @input='getFourthValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native="onSubmit('filterForm')")

      //- Dialog reseteo masivo
      ods-dialog(
        :title='$t("users.users_filters.button_reset_users")'
        :visible.sync="massResetDialogFormVisible"
        :append-to-body="true")
        ods-form(
          :model='massResetDialogForm')
          ods-form-item(:label='$t("auditory_doc_type.USER")')
            ods-tooltip(
                :content="$t('users.user_reset_tooltip')"
                placement='bottom-start')
              ods-input(
                v-model='massResetDialogForm.usersToReset')
        div(slot='footer')
          ods-button.btn_dialogreset(
            type='neutral'
            @click.native='handleCleanResetUser')
            | {{ $t('buttons.btnClear') }}
          ods-button(
            type='primary'
            :disabled='massResetDialogForm.usersToReset.length === 0'
            @click.native='handleResetUsers')
            | {{ $t('buttons.btnOk') }}

      //- Dialog carga masiva
      ods-dialog(
        :title='$t("users.users_filters.button_mass_usercharge")'
        :visible.sync="massChargeDialogFormVisible"
        ref='massChargeDialog',
        :append-to-body="true")
        div(style='margin-bottom: 2rem; font-size: larger')
          | {{ $t('users.user_mass_userchargemsg') }}
        ods-form.chargemassive(
          :rules='rulesDialogmassCharge',
          :model='massChargeDialogForm'
          ref='massChargeDialogForm')
          ods-form-item(v-if='this.userLoggedOneProject', prop='service', :label='$t("invoices.dialog_add_invoice.project.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='massChargeDialogForm.service',
              filterable,
              :placeholder='$t("users.filters.project.value")')
              ods-option(
                v-for='option in optionsService',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(prop='file', ref='form-item-upload')
            ods-upload(
              v-model='massChargeDialogForm.file',
              ref='upload',
              action='#',
              :auto-upload='false',
              :on-change='onSuccessUpload',
              :on-remove='handleRemoveUpload',
              accept= '.csv'
              :file-list='fileList')
                ods-button(
                  icon='ods-icon-plus',
                  size='small',
                  circle)
                  | {{ $t('users.user_upload') }}
          ods-form-item(style='text-align: right')
            ods-button(
              type='primary'
              @click.native="handleMassiveCharge('massChargeDialogForm')")
              | {{ $t('users.users_filters.button_mass_usercharge') }}

    .b2b-filters__container(v-if='listSelectedFiltersUsers.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')
        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersUsers',
          :key='index')

          b2b-filter-button-usuarios(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonUsuarios from '@/views/administracion/usuarios/B2bFilterButtonUsuarios'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-usuarios',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  data () {
    const _this = this
    return {
      userLoggedOneProject: true,
      // DatePicker
      dateTimePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Formulario
      filterForm: {
        firstValue: '',
        filterDatePickerValue: [],
        secondValue: '',
        secondValueNumber: '',
        secondValueSelect: '',
        thirdValue: '',
        fourthValue: '',
        fromRange: '',
        trial: '',
        toRange: ''
      },
      selected: {},
      selectedFilters: [],
      options: {},
      optionsService: [],
      auxListParties: [],
      massResetDialogFormVisible: false,
      massChargeDialogFormVisible: false,
      massResetDialogForm: {
        usersToReset: ''
      },
      tid: null,
      massChargeDialogForm: {
        service: null,
        file: null
      },
      extensionFormats: ['.csv'],
      fileList: [],
      // Reglas Validación
      rules: {
        // firstValue: [
        // { required: true, message: 'Campo obligatorio', trigger: 'change' }
        // ],
        trial: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 5, message: this.$t('msg_generics.max_num_character', { max: 5 }), trigger: 'change' },
          { pattern: /^[0-9]*$/, message: this.$t('msg_generics.number_required'), trigger: 'change' }
        ],
        filterDatePickerValue: [
          { required: true, message: this.$t('msg_generics.date_required'), trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { type: 'number', message: this.$t('msg_generics.number_required') }
        ],
        secondValueSelect: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
        // thirdValue: [
        // { required: true, message: 'Campo obligatorio', trigger: 'change' }
        // ],
        // fromRange: [
        //  { required: true, message: 'Campo obligatorio'},
        //  { type: 'number', message: 'Debe ser un número'}
        // ],
        // toRange: [
        //  { required: true, message: 'Campo obligatorio'},
        //  { type: 'number', message: 'Debe ser un número'}
        // ]

      },
      rulesDialogmassCharge: {
        service: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }
        ],
        file: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.attachments_table.fileselected'
            ),
            trigger: 'click'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'activeUser',
      'queryUsers',
      'listSelectedFiltersUsers',
      'optionsFilterUsersUsername',
      'optionsFilterUsersCompleteName',
      'optionsFilterUsersCreationDateTime',
      'optionsFilterUsersTrial',
      'optionsFilterUsersLastConnectionDate',
      'optionsFilterUsersIdNumber',
      'optionsFilterService',
      'optionsFilterUsersParty',
      'optionsFilterUsersEmail',
      // Permisos
      'canAdminUserAdvanced',
      'urlIn'
    ])
  },

  watch: {
    '$route' (to) {
      this.listSelectedFiltersUsers = this.listSelectedFiltersUsers // eslint-disable-line
    }
  },

  components: {
    B2bSearchBar,
    B2bFilterButtonUsuarios
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getUsers',
      'queryUsersState',
      'listSelectedFiltersUsersState',
      'getOptionsFilterParty',
      'optionsFilterUsersPartyState',
      'resetPasswordMassive',
      'getOptionsService',
      'optionsServicesEnabledState',
      'massiveUserUpload'
    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      if (type === 'partyType') {
        key = 'party_type.'
      }
      return this.$t(key + code)
    },
    // Ir a creacion de usuario
    handleGoCreateUser () {
      router.push({
        name: 'new-user'
      })
    },
    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },
    disabledDate (time) {
      return time.getTime() > Date.now()
    },
    async getPartiesResults (data) {
      const requestParty = {
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterParty(requestParty)
      this.selected.options = response
      this.auxListParties = response
      this.optionsFilterUsersPartyState(this.auxListParties)
    },
    async filterParties (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListParties = []
          this.optionsFilterUsersPartyState(this.auxListParties)
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async handleCleanResetUser () {
      this.massResetDialogForm.usersToReset = ''
    },
    async handleResetUsers () {
      const load = this.$loading({
        lock: true,
        text: this.$t('users.load.reset_password')
      })
      if (this.massResetDialogForm.usersToReset[this.massResetDialogForm.usersToReset.length - 1] === ';') {
        this.massResetDialogForm.usersToReset = this.massResetDialogForm.usersToReset.substring(0, this.massResetDialogForm.usersToReset.length - 1)
      }
      const addresses = this.massResetDialogForm.usersToReset.split(';')
      const dataQuery = {
        query: { username: addresses }
      }
      try {
        await this.resetPasswordMassive(dataQuery)
        this.$notify({
          title: this.$t('users.notify.reset_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('resetMassive CATCH: ' + error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.massResetDialogForm.usersToReset = ''
        this.massResetDialogFormVisible = false
      }
    },
    async handleMassiveCharge (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('handleMassiveCharge', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            if (!this.validateExtension(this.massChargeDialogForm.file.name)) {
              this.massChargeDialogForm.file = null
              this.fileList = []
              this.$notify({
                title: this.$t('msg_generics.format_invalid_req_csv'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            } else {
              await this.massiveUserUpload(this.massChargeDialogForm)
              // Reiniciamos formulario, cerramos dialog y mostramos notificacion
              this.$notify({
                title: this.$t('msg_generics.upload_attachment_ok'),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            }
          } catch (error) {
            console.log('handleMassiveCharge CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.massChargeDialogFormVisible = false
            this.refreshResults()
          }
        } else {
          return false
        }
      })
    },
    onSubmit (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const dataQuery = {
              query: {}
            }
            const column = this.selected.prop
            switch (column) {
              case 'username':
                this.queryUsers.username = this.selected.query.trim()
                break
              case 'completeName':
                this.queryUsers.name = this.selected.query[0]
                this.queryUsers.firstSurname = this.selected.query[1]
                this.queryUsers.secondSurname = this.selected.query[2]

                // Construimos el label que se consumirá en el componente filter
                this.selected.labelText = this.filterForm.secondValue + ' ' + this.filterForm.thirdValue + ' ' + this.filterForm.fourthValue
                break
              case 'trial':
                this.queryUsers.trial = this.selected.query
                break
              case 'enable':
                this.queryUsers.enable = this.selected.query
                break
              case 'lastConnectionDate':
                this.queryUsers.lastConnectionDateTimeFrom = this.selected.query[0]
                this.queryUsers.lastConnectionDateTimeTo = this.selected.query[1]
                break
              case 'idNumber':
                this.queryUsers.idNumber = this.selected.query.trim()
                break
              case 'projectId':
                this.queryUsers.projectId = this.selected.query
                break
              case 'partyId':
                this.queryUsers.partyId = this.selected.query
                break
              case 'partyType':
                this.queryUsers.partyType = this.selected.query
                break
              case 'isPartySponsor':
                this.queryUsers.isPartySponsor = this.selected.query
                break
              case 'email':
                this.queryUsers.mediaValue = this.selected.query.trim()
                this.queryUsers.mediaType = 'email'
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersUsers

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersUsersState(this.selectedFilters)

            this.selected = {}
            this.$refs[formName].resetFields()
            // Reseteamos el filtro de fechas aparte porque con resetFields no se resetea bien
            // cuando le ponemos un formato de fecha determinado
            this.filterForm.filterDatePickerValue = []

            this.queryUsers.page = 0
            await this.queryUsersState(this.queryUsers)
            dataQuery.query = this.queryUsers

            const users = await this.getUsers(dataQuery)
            this.totalResults = users.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // Emite el Evento al Padre con los nuevos Datos de la Fecha
    async getDateTimePickerValue () {
      console.log('getDateTimePickerValue: ', this.dateTimePickerValue)
      if (!this.dateTimePickerValue) {
        this.queryUsers.creationDateTimeFrom = ''
        this.queryUsers.creationDateTimeTo = ''
      } else {
        this.queryUsers.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryUsers.creationDateTimeTo = this.dateTimePickerValue[1]
      }

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_date')
      })
      try {
        await this.queryUsersState(this.queryUsers)
        dataQuery.query = this.queryUsers
        const users = await this.getUsers(dataQuery)
        this.totalResults = users.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.queryUsersState(this.queryUsers)
        dataQuery.query = this.queryUsers
        const users = await this.getUsers(dataQuery)
        this.totalResults = users.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.massChargeDialogForm.file = file
      this.$refs.massChargeDialogForm.validateField('file')
    },
    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('file')
      this.fileList = []
    },
    // Filtro Fechas Emision
    getDateRangePickerValue () {
      console.log('FILTRO SELECCIONADO ', this.selected)
      console.log('getDatePickerValue: ', this.filterForm.filterDatePickerValue)

      this.selected.query = this.filterForm.filterDatePickerValue
      // this.filterForm.secondValueSelect = this.selected
      this.getSecondValue(this.selected)
    },
    async handleGoResetUsers () {
      this.massResetDialogFormVisible = true
      this.massResetDialogForm.usersToReset = ''
    },
    async handleGoMassiveCharge () {
      this.massChargeDialogForm.file = null
      this.massChargeDialogForm.service = null
      this.fileList = []
      const dataQueryService = { page: 0, size: 1000, enabled: true, sort: 'name,ASC' }
      this.optionsService = await this.getOptionsService(dataQueryService)
      if (this.optionsService.length === 1) {
        console.log(this.optionsService[0])
        this.massChargeDialogForm.service = this.optionsService[0].id
        this.userLoggedOneProject = false
      }
      this.massChargeDialogFormVisible = true
    },
    getFirstValue (data) {
      this.filterForm.trial = ''
      this.filterForm.secondValue = ''
      if (data.col === 'completeName') {
        this.filterForm.thirdValue = ''
        this.filterForm.fourthValue = ''
      }
      this.$refs.filterForm.clearValidate()
      this.selected = data

      const aux = []
      this.optionsFilterUsersPartyState(aux)
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        if (this.selected.prop === 'isPartySponsor' || this.selected.prop === 'enable') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.value
          this.selected.labelText = this.$t('msg_generics.question.' + option.type)
        } else if (this.selected.prop === 'partyType') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.value
          this.selected.labelText = this.formatterLabel(option.type)
        } else if (this.selected.prop === 'projectId') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.name
        } else if (this.selected.prop === 'partyId') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.tradeName
        }
      } else if (this.selected.componente === 'date') {
        this.selected.labelText = data.query
      }

      if (this.selected.componente === 'input') {
        if (this.selected.col === 'completeName') {
          this.selected.query[0] = data
          this.selected.query[1] = this.filterForm.thirdValue
          this.selected.query[2] = this.filterForm.fourthValue
        } else {
          this.selected.query = data
          this.selected.labelText = data
        }
      }

      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      this.filterForm.thirdValue = data
      this.selected.query[1] = this.filterForm.thirdValue
    },

    getFourthValue (data) {
      this.filterForm.fourthValue = data
      this.selected.query[2] = this.filterForm.fourthValue
    },

    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)
      this.selectedFilters = []
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        this.selectedFilters = this.listSelectedFiltersUsers.map(item => {
          item.labelText = ''
          if (item.col === 'completeName') {
            item.query[0] = ''
            item.query[1] = ''
            item.query[2] = ''
          } else {
            item.query = ''
          }
          item.selected = false
          return item
        })

        console.log('CLEAR FILTERS: ', this.selectedFilters)
        await this.listSelectedFiltersUsersState(this.selectedFilters)

        if (!this.dateTimePickerValue) {
          this.queryUsers.creationDateTimeFrom = ''
          this.queryUsers.creationDateTimeTo = ''
        } else {
          this.queryUsers.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryUsers.creationDateTimeTo = this.dateTimePickerValue[1]
        }
        this.queryUsers.username = ''
        this.queryUsers.name = ''
        this.queryUsers.firstSurname = ''
        this.queryUsers.secondSurname = ''
        this.queryUsers.trial = ''
        this.queryUsers.enable = ''
        this.queryUsers.lastConnectionDateTimeFrom = ''
        this.queryUsers.lastConnectionDateTimeTo = ''
        this.queryUsers.idNumber = ''
        this.queryUsers.projectId = ''
        this.queryUsers.partyId = ''
        this.queryUsers.partyType = ''
        this.queryUsers.isPartySponsor = ''
        this.queryUsers.mediaType = ''
        this.queryUsers.mediaValue = ''

        dataQuery.query = this.queryUsers
        const users = await this.getUsers(dataQuery)
        await this.queryUsersState(this.queryUsers)
        this.totalResults = users.data.totalElements
        this.selectedFilters = []
        await this.listSelectedFiltersUsersState(this.selectedFilters)

        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersUsersState(data.listAfterRemove)
      this.initForm()
    },

    initForm () {
      if (!this.options.username.selected) {
        this.filterForm.firstValue = this.options.username
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      let errorArgList = []
      errorArgList = error.data.errorArgList
      if (errorArgList !== null && errorArgList[0].codesList !== null) {
        for (let i = 0; i < errorArgList.length; i++) {
          let fullMessage = ''
          for (let j = 0; j < errorArgList[i].codesList.length; j++) {
            if (errorArgList[i].codesList != null) {
              fullMessage = fullMessage + errorArgList[i].codesList[j] + '. '
            }
          } if (errorArgList[i].arguments === 'Ok.') {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 60000
            })
          } else {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 60000
            })
          }
        }
      } else {
        this.showNotificationError(error)
      }
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersUsers)

    const dataQueryService = { page: 0, size: 1000, sort: 'name,ASC' }
    this.optionsService = await this.getOptionsService(dataQueryService)
    await this.optionsServicesEnabledState(this.optionsService)

    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
    if (this.activeUser.data.projects && this.activeUser.data.projects.length < 2) {
      delete this.options.servicio
    }
    this.initForm()
    if (this.queryUsers.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryUsers.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryUsers.creationDateTimeTo)
    }
    try {
      await this.queryUsersState(this.queryUsers)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    this.options.nombre_completo.options = this.optionsFilterUsersCompleteName
    this.options.intentos.options = this.optionsFilterUsersTrial
    this.options.fecha_ultima_conexion.options = this.optionsFilterUsersLastConnectionDate
    if (this.optionsFilterService.length > 1) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.empresa.options = this.optionsFilterUsersParty
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
::v-deep .chargemassive .ods-input__suffix {
    height: 35px !important;
}
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }
  .rightbut{
    padding: 8px 10px;
    display: inline;
    margin-right: 1rem;
  }
  .ods-button{
    padding: 8px 10px;
    display: inline;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      .ods-date-editor {
        min-width: rem(214.4);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }
    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
